<template>
    <div>
        <!-- unit info -->
        <div class="mb-2">{{ getStrByLng().LABEL_RECORDS }}</div>
        <!-- records table -->
        <div class="max-laptop:overflow-x-auto relative">
            <table class="w-full border border-black/10">
                <tbody>
                    <tr v-for="(record, index) in translatedRecordList" :key="index">
                        <td class="w-52 min-w-52 text-left">{{ record.Name }}</td>
                        <td class="min-w-72 text-left">
                            <div class="flex">
                                <NocFlag class="mr-1" :nat-code="record.Holder_Nation" />
                                <WtcName :competitor-name="{ Name: record.Holder }" />
                            </div>
                        </td>
                        <td class="w-20 min-w-20">{{ record.Performance }}</td>
                        <td class="w-80 min-w-80 text-left">{{ record.Date }} {{ record.Location }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTranslatedProperty } from "@swisstiming/owl-core";
import { getStrByLng, WtcName } from "@swisstiming/webtec-kit";
import { computed } from "vue";

import { IRecord } from "../interfaces/wdl-archive.interfaces";
import NocFlag from "./elements/NocFlag.vue";

const props = withDefaults(
    defineProps<{
        records?: IRecord[];
    }>(),
    {}
);

const translatedRecordList = computed(() =>
    props?.records?.map((record) => {
        record.Name = useTranslatedProperty<IRecord>(record, "Name", "Names");
        return record;
    })
);
</script>

<style lang="scss"></style>
